import React from "react";

const labelStyle = {
  position: "absolute",
  fontSize: "12px",
  color: "#666",
  zIndex: 10,
  pointerEvents: "none",
  whiteSpace: "nowrap",
};

// Metres shown as-is when whole ("10m"), one decimal for midpoints ("5.0m").
const formatMeters = (m, isMid) => (isMid ? `${m.toFixed(1)}m` : `${m}m`);

// Half a pixel of slack: at zoom 1 the far ticks land on the canvas edge
// itself, give or take float error.
const isInside = (px, size) => px >= -0.5 && px <= size + 0.5;

// Ticks are positioned through the viewport, so the y axis is y-up by
// construction: the floor height sits at the top, 0 at the bottom. Under the
// editor's zoom they move with the floor, and a tick that would land outside
// the canvas is dropped rather than drawn over the card.
const CanvasAxisLabels = ({ dimensions, canvasSize, viewport }) => {
  if (!viewport?.isValid) return null;
  const { width, height } = dimensions;
  const yTicks = [
    { m: height, shift: "0" },
    { m: height / 2, shift: "-50%", mid: true },
    { m: 0, shift: "-100%" },
  ]
    .map((t) => ({ ...t, px: viewport.project({ x: 0, y: t.m }).y }))
    .filter((t) => isInside(t.px, canvasSize.height));
  const xTicks = [
    { m: 0, shift: "-50%" },
    { m: width / 2, shift: "-50%", mid: true },
    { m: width, shift: "-50%" },
  ]
    .map((t) => ({ ...t, px: viewport.project({ x: t.m, y: 0 }).x }))
    .filter((t) => isInside(t.px, canvasSize.width));

  return (
    <>
      {/* Y-axis labels (left side) */}
      <div style={{ ...labelStyle, left: 2, top: 0 }}>
        {yTicks.map(({ m, shift, mid, px }) => (
          <span
            key={m}
            data-testid={`y-tick-${m}`}
            style={{
              ...labelStyle,
              left: 0,
              top: `${px}px`,
              transform: `translateY(${shift})`,
            }}
          >
            {formatMeters(m, mid)}
          </span>
        ))}
      </div>

      {/* X-axis labels (bottom) */}
      <div
        style={{
          ...labelStyle,
          top: canvasSize.height + 2,
          left: 40,
        }}
      >
        {xTicks.map(({ m, shift, mid, px }) => (
          <span
            key={m}
            data-testid={`x-tick-${m}`}
            style={{
              ...labelStyle,
              top: 0,
              left: `${px}px`,
              transform: `translateX(${shift})`,
            }}
          >
            {formatMeters(m, mid)}
          </span>
        ))}
      </div>
    </>
  );
};

export default CanvasAxisLabels;
